export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";

export const USER_LOADED = "USER_LOADED";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

// Expense
export const ADD_EXPENSE = "ADD_EXPENSE";
export const GET_EXPENSES = "GET_EXPENSES";
export const CLEAR_EXPENSES = "CLEAR_EXPENSES";
export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const EXPENSE_ERROR = "EXPENSE_ERROR";

// Current
export const SET_CURRENT = "SET_CURRENT";
export const CLEAR_CURRENT = "CLEAR_CURRENT";

//Filter
export const FILTER_EXPENSES = "FILTER_EXPENSES";
export const CLEAR_FILTER = "CLEAR_FILTER";

// Alert
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

//set loading
export const SET_LOADING = "SET_LOADING";

//Category
export const ADD_CATEGORY = "ADD_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const CLEAR_CATEGORIES = "CLEAR_CATEGORIES";
export const CATEGORY_ERROR = "CATEGORY_ERROR";
